import React from "react";
import "./chat-container.scss";

export type ChatContainerAlignment = "left" | "right";

export interface ChatContainerProps {
  senderName: string;
  timestamp: string;
  message: React.ReactNode;
  senderNameColor?: string;
  timestampColor?: string;
  messageColor?: string;
  backgroundColor?: string;
  borderRadius?: string;
  maxWidth?: string;
  alignment?: ChatContainerAlignment;
  className?: string;
}

export const ChatContainer: React.FC<ChatContainerProps> = ({
  senderName,
  timestamp,
  message,
  senderNameColor = "#0056D6",
  timestampColor = "#8A8A8A",
  messageColor = "#1F1F1F",
  backgroundColor = "#EDF2FA",
  borderRadius = "0.75rem",
  maxWidth = "100%",
  alignment = "left",
  className = "",
}) => {
  return (
    <div
      className={`chat-container chat-container--${alignment} ${className}`}
    >
      <div
        className="chat-container__bubble"
        style={{ backgroundColor, borderRadius, maxWidth }}
      >
        <div className="chat-container__header">
          <span
            className="chat-container__sender"
            style={{ color: senderNameColor }}
          >
            {senderName}
          </span>
          <span
            className="chat-container__timestamp"
            style={{ color: timestampColor }}
          >
            {timestamp}
          </span>
        </div>
        <div
          className="chat-container__message"
          style={{ color: messageColor }}
        >
          {message}
        </div>
      </div>
    </div>
  );
};
